<template>
  <div v-if="images" class="image-modal">
    <div class="image-modal__button-container">
      <SiteLink class="image-modal__button-close btn --red" icon="close" :to="{ name: $route.name, query: null }"/>
    </div>
    <div class="image-modal__images-container">
      <button @click.prevent="lastImage()"
              :class="['image-modal__next-prev btn --white r180',  {'transparent': images.length <= 1}]">
        <Icon id="tail-arrow"/>
      </button>
      <Transition name="img-fade" mode="out-in">
        <img :key="`image-${current}`" v-if="images[current]" :src="images[current].url" alt=""/>
      </Transition>
      <span class="image-modal__img-bg"></span>
      <button @click.prevent="nextImage()"
              :class="['image-modal__next-prev btn --white', {'transparent': images.length <= 1}]">
        <Icon id="tail-arrow"/>
      </button>
    </div>
  </div>
  <Loader v-else/>
</template>

<script>
import {Icon} from '@/components/global'
import {Loader, SiteLink} from '@/components/small'

export default {
  name: 'ImageFullWidth',
  components: {
    Icon,
    Loader,
    SiteLink
  },
  data() {
    return {
      current: 0,
    }
  },
  computed: {
    images() {
      if (this.$route.query.a) {
        const actuality = Array.from(this.$actuality.all).find(({ id }) => id.toString() === this.$route.query.a.toString())

        return actuality ? actuality.images : null 
      } else {
        const notice = Array.from(this.$notice.all).find(({ id }) => id.toString() === this.$route.query.n.toString())

        return notice ? notice.images : null 
      }
    }
  },
  methods: {
    lastImage() {
      if (this.current - 1 >= 0) {
        return this.current -= 1
      }

      this.current = this.images.length - 1
    },
    nextImage() {
      if (this.current + 1 < this.images.length) {
        return this.current += 1
      }

      this.current = 0
    }
  },
  beforeMount() {
    this.current = parseInt(this.$route?.query?.i ?? '1') - 1
  }
}
</script>